<div id="cra-payment-actions">
    <ng-select
        wcag-label
        [placeholder]="'COMMON.actionsLabel.actions' | translate"
        [inputAttrs]="{'aria-label': 'COMMON.actionsLabel.actions' | translate}"
        [items]="actionsList"
        bindLabel="workflowAction"
        bindValue="workflowAction"
        (change)="triggerActionController($event)"
        appendTo=".p-datatable-table-container table"
        [clearable]="false"
        [searchWhileComposing]="false"
        [typeToSearchText]="false"
        [(ngModel)]="dummyModel"
    >
    </ng-select>
</div>
